import React, { useState } from 'react';
import { orderBy } from 'lodash';
import { Form } from 'react-bootstrap';

import PagoList from './PagoList';
import PagoForm from './PagoForm';
import Uuid from '../../../../support/Uuid';
import FactorajeForm from './FactorajeForm';
import FactorajeFinancieroPagoCalculator from '../../support/factoraje/FactorajeFinancieroPagoCalculator';

const PagoManager = (props) => {
  const [editing, setEditing] = useState(null);
  const [show, setShow] = useState({
    form: false,
  });

  const handleOnAdd = (value) => {
    const { Pago = [] } = props.data;

    const newData = Pago.concat([
      {
        id: Uuid.v4(),
        ...value,
      },
    ]);

    if (editing) {
      setEditing(null);
      setShow({
        ...show,
        form: false,
      });
    }

    handleOnListChange(newData);
  };

  const handleOnEdit = (item) => {
    setEditing(item);

    setShow({
      ...show,
      form: true,
    });

    const { Pago } = props.data;

    const newData = Pago.filter((value) => value.id !== item.id);

    handleOnListChange(newData);
  };

  const handleOnDelete = (item) => {
    const { Pago } = props.data;

    const newData = Pago.filter((value) => item.id !== value.id);

    handleOnListChange(newData);
  };

  const handleOnListChange = (data) => {
    props.onChange(
      {
        ...props.data,
        Pago: orderBy(data, 'NumParcialidad', 'asc'),
      },
      !!editing ? false : true
    );
  };

  const handleOnFactorajeChange = (event) => {
    const Pago = FactorajeFinancieroPagoCalculator.make({
      data: {
        ...props.input,
        ...props.data,
        FactorajeFinanciero: event,
      },
    }).apply();

    props.onChange({
      ...props.data,
      FactorajeFinanciero: {
        ...event,
      },
      Pago: Pago,
    });
  };

  const handleOnCheckboxChange = (event) => {
    const { name, checked } = event.target;

    if (!checked) {
      // Resetear
    }

    setShow({
      ...show,
      [name]: checked,
    });
  };

  const { data, input } = props;
  const { Pago = [] } = data;

  return (
    <>
      <FactorajeForm
        data={data.FactorajeFinanciero || {}}
        input={input}
        onChange={handleOnFactorajeChange}
      />

      <Form.Group controlId="form">
        <Form.Check
          type="checkbox"
          name="form"
          label="Nuevo Pago"
          checked={show.form || false}
          onChange={handleOnCheckboxChange}
        />

        {show.form && (
          <PagoForm
            editing={editing}
            onAdd={handleOnAdd}
          />
        )}
      </Form.Group>

      <PagoList
        data={Pago}
        onEdit={editing ? () => {} : handleOnEdit}
        onDelete={handleOnDelete}
      />
    </>
  );
};

export default PagoManager;
